export const ORGANIZATION_ROLES = ["Owner", "Administrator", "Manager", "Employee"];
export const ACCOUNTING_OPERATIONS = ["archive", "intake", "purchases", "banking", "quickbooks", "declarations", "ledger"];

const ADMIN_ROLES = new Set(["Owner", "Administrator"]);
const ACCOUNTING_ROLES = new Set(ORGANIZATION_ROLES);

export const hasOrganizationAccess = (profile) => Boolean(profile && !["Invited", "Suspended"].includes(profile.status) && ORGANIZATION_ROLES.includes(profile.role));
export const canManageOrganization = (profile) => hasOrganizationAccess(profile) && ADMIN_ROLES.has(profile.role);
export const canManageTeam = (profile) => canManageOrganization(profile);
export const canUseAccountingOperations = (profile) => hasOrganizationAccess(profile) && ACCOUNTING_ROLES.has(profile.role);
export const canUseAccountingOperation = (profile, operation) => {
  if (!canUseAccountingOperations(profile) || !ACCOUNTING_OPERATIONS.includes(operation)) return false;
  if (canManageOrganization(profile)) return true;
  return profile.accountingPermissions?.includes("*")
    || profile.accountingPermissions?.includes(operation)
    || (operation === "archive" && profile.accountingPermissions?.includes("intake"));
};
export const hasAllBusinessAccess = (profile) => canManageOrganization(profile) || profile?.businessIds?.includes("*");

export const canAccessBusiness = (profile, businessId) => {
  if (!hasOrganizationAccess(profile) || !businessId) return false;
  return hasAllBusinessAccess(profile) || profile.businessIds?.includes(businessId);
};

export const accessibleBusinesses = (businesses, profile) => businesses.filter((business) => canAccessBusiness(profile, business.id));

export const canAccessClient = (profile, client) => Boolean(client) && (!client.issuerId
  ? hasOrganizationAccess(profile)
  : canAccessBusiness(profile, client.issuerId));

export const canAccessInvoice = (profile, invoice) => canAccessBusiness(profile, invoice?.issuerId);

export const accessDeniedMessage = "You do not have access to that managed business.";
